<!--  -->
<template>
  <div :class="{'actvie-color-og': activeTab == 1, 'active-color-school': activeTab == 2}" class="product-box">
    <!-- <swiper v-for="(item, index) in prouctInfo" :key='index' v-if="item.tab===activeTab" :listInfo="item.listImg" :hasBtn="true"></swiper> -->
    <div class="product-content-wrapper">
      <Ptitle :chineseTitle="title.chinese" :enTitle="title.english" ></Ptitle>
      <div class="nav-wrapper">
        <div class="normal" v-for="(item, index) in prouctInfo" @click="changeTab(item.tab)" :key="index">
          <div :class="{active: item.tab === activeTab}" >
            {{item.title}}
            <span class="active-line"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="main-wrapper">
      <yunejia v-if="activeTab === 0" ref="mainpage"></yunejia>
      <og v-if="activeTab === 1" ref="mainpage"></og>
      <school v-if="activeTab === 2" ref="mainpage"></school>
    </div>

    <div class="bottom-btn-group">
      <span v-for="(itemSub, indexSub) in prouctInfo[activeTab].listPage"  style="width: 30px; border-radius: 4px; margin-right:10px;" :style="{ height: indexSub ==  activePage ? '4px' : '2px'}" :class="{active: indexSub ==  activePage}" @click="toPage(indexSub)" :key="indexSub"></span>
    </div>

    <div class="prev-button" @click="prevPage" v-show="activePage > 0"></div>
    <div class="next-button" @click="nextPage" v-show="activePage < prouctInfo[activeTab].listPage.length - 1"></div>

  </div>
</template>

<script>
import Ptitle from '../../../components/header/title'
import yunejia from './productBox/yunejia'
import og from './productBox/og'
import school from './productBox/school'

export default {
  data () {
    return {
      prouctInfo: [
        {
          tab: 0,
          title: '孕e家',
          listPage: [0, 1]
        },
         {
          tab: 1,
          title: 'Dr默',
          listPage: [0,1,2,3]
        },
         {
          tab: 2,
          title: '孕妇学校',
          listPage: [0, 1, 2]
        },
      ],
      activeTab: 0,
      activePage: 0,
      height: '4px',
      title: {
        chinese: '产品介绍',
        english: 'PRODUCTS'
      }
    }
  },

  props: [],

  watch: {},

  components: {
    Ptitle,
    yunejia,
    og,
    school
  },

  computed: {},

  created () {},

  methods: {
    changeTab(tab) {
      this.activeTab = tab;
      this.activePage = 0;
      this.$refs.mainpage.activePage = 0;
    },
    prevPage() {
      const activeTab = this.activeTab;
      this.activePage = this.$refs.mainpage.activePage - 1;
      this.$refs.mainpage.activePage = this.$refs.mainpage.activePage - 1;
    },
    nextPage() {
      const activeTab = this.activeTab;
      this.activePage = this.$refs.mainpage.activePage + 1;
      this.$refs.mainpage.activePage = this.$refs.mainpage.activePage + 1;
    },
    toPage(page) {
      this.activePage = page;
      this.$refs.mainpage.activePage = page;
    }
  }
}

</script>
<style lang='scss' scoped>
.actvie-color-yunejia { background: rgb(255,248,250)!important;}
.actvie-color-og { background: rgba(255,156,102,0.05)!important;}
.active-color-school { background: rgba(213,68,252,0.05)!important;}

.product-box {
  width: 100%;
  min-height: 100vh;
  background: rgb(255,248,250);
  position: relative;
  .product-content-wrapper {
    width:100%;
    margin-top:50px;
    position: absolute;
    top:0;
    z-index:10;
    .nav-wrapper {
      margin-top:50px;
      width:100%;
      display: flex;
      justify-content: center;
      color: #999;
      font-size:18px;
      line-height: 25px;
      .normal {
        display: inline-block;
        vertical-align: top;
        display: flex;
        justify-content: center;
        width: 15%;
        text-align: center;
        font-weight: 500;
        cursor: pointer;
      }
      .normal:hover {
        font-weight: 900;
        color: #FF789E;
      }
      .active {
        display: inline-block;
        vertical-align: top;
        color: #FF789E;
        width: 70px;
        width: fit-content;
        font-weight: 900;
        cursor: pointer;
        .active-line {
          width: 140%;
          margin-left:-20%;
          height: 3px;
          background: #FF789E;
          display: inline-block;
        }
      }
    }
  }
  .prev-button{position: absolute; top: 51vh; left: 150px;background:url("../../../assets/images/arrow_left.png") ; background-size: 100% 100%; background-repeat: no-repeat;width: 80px; height: 80px;}
  .next-button{position: absolute; top: 51vh; right: 150px;background:url("../../../assets/images/arrow_right.png"); background-size: 100% 100%; background-repeat: no-repeat;width: 80px; height: 80px;}
  .prev-button:hover, .next-button:hover { cursor: pointer;}
  .bottom-btn-group {
    position: absolute;
    bottom: 8vh;
    width: 100%;
    display: flex;
    justify-content: center;
    span {
      display: inline-block;
      background: #E0E0E0;
      border-radius: 4px;
      opacity: 1;
      margin-right: 10px;
    }
    .active {
     background: #FF789E;
    }
  }

  .main-wrapper {
    width: 100%;
    position: absolute;
    top: 25vh;
    bottom: 9vh;
  } 
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/productBox.vue